<script>
    export let header = "";
    export let icon = "";
    export let align = "";
    export let disabled = false;

    let cardTable = false;
    export let width="100%";
    export let marginRight="0";

    let cardTableClass = "";
    if (cardTable){
        cardTableClass = "with-table";
    }
    if (align.length > 1) {
        align = "text-" + align;
    }
</script>


<div class="card {disabled ? 'disabled' : ''}" style="width:{width};margin-right:{marginRight}">
    {#if $$slots.header}
        <div class="card-header">
            <slot name="header"></slot>
        </div>
    {/if}
    {#if $$slots.body}
    <div class="card-body {align} {cardTableClass}">
        {#if icon.length > 0}
            <span class="material-icons">{icon}</span>
        {/if}
        {#if (header.length > 0) }
            <h5>{header}</h5>
        {/if}
        <slot name="body"></slot>
    </div>
    {/if}
    {#if $$slots.footer}
        <div class="card-footer">
            <slot name="footer"></slot>
        </div>
    {/if}
</div>

<style>
.material-icons{
    font-size:74px;
}

.disabled{
    background-color: #fffbfb33;
    color: grey;
}
</style>